@let sourceIdValue = sourceId();
@if (sourceIdValue) {
    <app-imports-monitoring-channel-drilldown></app-imports-monitoring-channel-drilldown>
} @else {
    <app-imports-monitoring-channel-overview></app-imports-monitoring-channel-overview>
}
